export default __webpack_public_path__ + "static/media/contract.423c0d8b.svg";